export const SYSTEM_MESSAGES = {
    CREATED: 'Prospect has been successfully created',
    UPDATED: 'Profile has been successfully updated',
    DELETED: 'Prospect has been successfully archived',
    DELETE_CONFIRM: 'Are you sure you want to archive prospect',
};

export const SNACK_TIMEOUT = 5000;
export const DEBOUNCE = 400;